<template>
  <div>
    <div v-if="departments.length > 1">
      <div v-if="showLabel">
        {{ $t('department') }}*
      </div>
      <dara-select
        v-bind="$attrs"
        :name="$t('department-field')"
        rules="required"
        :class="showLabel ? 'mt--md' : ''"
        @on-change="onChange">
        <option :value="null" disabled>{{ $t('select-department') }}</option>
        <option
          v-for="department in departments"
          :key="department.id"
          :value="department.id">
          {{ department.name }}
        </option>
      </dara-select>
    </div>
    <div v-else-if="departments[0]" class="mb-3 mt-4">
      {{ $t('department') }}: "<strong>{{ departments[0].name }}</strong>"
      <br>
      <small v-if="user.permission > 1" class="color--info">{{ $t('your-company-only-have-this-department') }}</small>
      <small v-else class="color--info">{{ $t('you-are-not-allowed-to-choose-departments') }}</small>
    </div>
    <div v-else class="mb-3 mt-4">
      <dara-p color="danger">
        * {{ $t('your-company-has-no-departments') }}
        <br>
        <dara-small class="cursor--pointer color--primary">
          <div @click="onNewDepartment()">
            {{ $t('click-here') }}
            <dara-invisible class="color--info">{{ $t('to-add-a-new-department') }}</dara-invisible>
          </div>
        </dara-small>
      </dara-p>
    </div>
  </div>
</template>

<script>
import { fetchDepartments, getDepartmentById } from '@/modules/department/department.service';
import { getters } from '@/modules/user/user.store';
import { translate } from '@/services/translate.service';

export default {
  name: 'DaraDepartmentChooser',
  props: {
    showLabel: {
      type: Boolean,
      default: true,
    },
    isFilter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      departments: [],
      user: getters.getUser(),
    };
  },
  created() {
    this.onfetch();
  },
  methods: {
    onfetch() {
      if (this.user.permission > 1) {
        fetchDepartments()
          .then(data => {
            this.departments = data.data;
            if (this.isFilter) this.departments.push({ id: 'all', name: translate('all-departments') });
            if (this.departments.length === 1) {
              this.onChange(this.departments[0].id);
            }
          })
          .catch(() => {
            this.departments = null;
          });
      } else {
        getDepartmentById(this.user.department_id)
          .then(data => {
            this.departments = [data];
            this.onChange(data.id);
          })
          .catch(() => {
            this.departments = null;
          });
      }
    },
    onChange(id) {
      this.$emit('on-change', { id });
    },
    onNewDepartment() {
      this.$emit('onNewDepartment');
    },
  },
};
</script>
